// extracted by mini-css-extract-plugin
export default {"primaryColor":"#141414","secondaryColor":"#fd5b05"};